module.exports = "/matchcenter-staging/assets/images/matchcenter_no_data.1d9f1defc2b65fc712ad7bc11d220d88.svg";